<script setup lang="ts">
/**
 * A panel switch of the office status bar (navigation pane, format panel):
 * an icon (`icon` slot), optionally a short visible `text`, pressed while the
 * panel is open. `label` is its title and accessible name. Put the switches
 * into a `.nx-office-statusbar__views` group in the bar's `end` slot.
 */
import '../office-statusbar.css';

const props = withDefaults(
  defineProps<{
    /** Title and accessible name — what the panel is. */
    label: string;
    /** The panel is open. */
    pressed: boolean;
    /** A short visible label beside the icon (the compact bar shows it). */
    text?: string;
  }>(),
  { text: undefined }
);
</script>

<template>
  <button
    type="button"
    class="nx-office-statusbar__toggle"
    :class="{ 'has-text': !!props.text }"
    :title="props.label"
    :aria-label="props.label"
    :aria-pressed="props.pressed"
  >
    <slot name="icon" />
    <span v-if="props.text">{{ props.text }}</span>
  </button>
</template>
